import { useState } from "react";

// Provides shared state and handlers for draggable window visibility, maximize, and position.
export const useWindowBehavior = ({ initialPosition = { x: 0, y: 0 } } = {}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isMaximized, setIsMaximized] = useState(false);
  const [position, setPosition] = useState(initialPosition);

  const handleClose = (onClose) => {
    setIsVisible(false);
    if (onClose) {
      onClose();
    }
  };

  const handleMinimize = (onMinimize) => {
    setIsVisible(false);
    if (onMinimize) {
      onMinimize();
    }
  };

  const handleMaximise = (onMaximize) => {
    const nextValue = !isMaximized;
    setIsMaximized(nextValue);

    if (onMaximize) {
      onMaximize(nextValue);
    }
  };

  const handleDrag = (data) => {
    setPosition({ x: data.x, y: data.y });
  };

  return {
    isVisible,
    isMaximized,
    position,
    handleClose,
    handleMinimize,
    handleMaximise,
    handleDrag,
  };
};
